import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ParamsService {
  parametros: Map<string, any> = new Map<string, any>();

  constructor() {}

  limpiarParametros() {
    this.parametros.clear();
  }

  procesarParametros(params: URLSearchParams) {
    params.forEach((value, key, parent) => {
      this.parametros.set(key, value);
    });
  }
}
